/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable max-statements */
import React, { useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import './dashCard.css';
import moment from 'moment';
import {
	setSelectedSection,
	setTab
} from '../../../redux/actions/sideBarAction';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import DashboardAddModalContent from './dashboardAddModalContent';
import { DashCard } from './singleDash';
import LoadingRectanglesAnimation from '../../Utils/LoadingAnimations/LoadingRectanglesAnimation';
import {
	FaFacebook,
	FaInstagram,
	FaPinterest,
	FaTwitter,
	FaYoutube
} from 'react-icons/fa';
import { globalEnv } from '../../../config/baseConfig';
import { DataNotFoundAnimation } from '../../Utils/ErrorAnimations/dataNotFoundAnim';
import LoadingAnimComponent from '../../Utils/LoadingAnimations/loadingAnimation';
import LazyImage from '../../Utils/Components/lazyImageComponent';
import Pagination from '../../Utils/Pagination';
import axiosInstance from '../../../config/axiosInstance';
import TopicCard from '../Topic/topicCard';
import { Tag } from '../Topic/tag';
import ParentModal from '../../Utils/Components/modals/parentModal';
import { hideSearchbarAction } from '../../../redux/actions/searchBarAction';
import SearchBar from '../../Utils/Components/searchBar';
import { sortingOrder } from '../../Utils/sortingOrder';

const queryClient = new QueryClient();

export default function User() {
	const { user }: any = useTypedSelector((state) => state.auth);
	const { id } = useParams();
	const [isProfile] = useState(user._id === id);
	const dispatch = useDispatch();
	dispatch(setSelectedSection('User Details'));
	dispatch(hideSearchbarAction());

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	useEffect(() => {
		if (isProfile) dispatch(setTab('profile'));
		else dispatch(setTab('documents'));
	}, [isProfile]);
	return (
		<QueryClientProvider client={queryClient}>
			<div className="w-full h-full pt-16 ">
				<UserDetails
					id={id!}
					isProfile={isProfile}
					ACCESS_TOKEN={ACCESS_TOKEN}
				/>
			</div>
		</QueryClientProvider>
	);
}

type UserDetailsProps = {
	id: string;
	isProfile: boolean;
	ACCESS_TOKEN: string;
};

function UserDetails({ id, isProfile, ACCESS_TOKEN }: UserDetailsProps) {
	const [userId, setUserId] = useState('');
	const [username, setUsername] = useState('');
	const [email, setEmail] = useState('');
	const [photo, setPhoto] = useState(null);
	const [isDisabled, setIsDisabled] = useState(false);
	const [isBlocked, setIsBlocked] = useState(false);
	const [defaultDash, setDefaultDash] = useState('');

	const [singleDash, setSingleDash] = useState(false);
	const [signupDate, setSignupDate] = useState(null);
	const [bio, setBio] = useState('');
	const [gender, setGender] = useState('male');
	const [birthdate, setBirthdate] = useState<Date | null>(new Date());
	const [location, setLocation] =
		useState<{ city?: string; country?: string }>();

	const [instagramLink, setInstagramLink] = useState(null);
	const [facebookLink, setFacebookLink] = useState(null);
	const [youtubeLink, setYoutubeLink] = useState(null);
	const [twitterLink, setTwitterLink] = useState(null);
	const [pinterestLink, setPinterestLink] = useState(null);

	const [isAddDashModalOpen, setDashModalOpen] = useState(false);
	const [isAddDashModalChanged, setIsAddDashModalChanged] = useState(false);

	const [isWarnModalOpen, setIsWarnModalOpen] = useState(false);

	const [dashboards, setDashboards] = useState<any[]>([]);
	const [createdTopics, setCreatedTopics] = useState<any[]>([]);

	const [reloadCount, setReloadCount] = useState(0);
	const [searchParams, setSearchParams] = useSearchParams();
	const urlPage = searchParams.get('page');
	const [page, setPage] = useState(
		urlPage != null && !isNaN(parseInt(urlPage)) ? parseInt(urlPage) : 1
	);
	const [searchQuery, setSearchQuery] = useState<string>();
	const [sortOrder, setSortOrder] = useState<string>();
	const [sortBy, setSortBy] = useState<string>();

	const [tags, setTags] = useState<string[]>([]);
	const [isShowingContributedTopics, setIsShowingContributedTopics] =
		useState(false);

	// handleResize() & dimensions are added to update the dashboard card text size when resizing the window
	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});

	useEffect(() => {
		if (page != null) {
			if (page === 1) {
				searchParams.delete('page');
				setSearchParams(searchParams);
			} else history.pushState(history.state, 'user', `?page=${page}`);
		}
	}, [page]);

	useEffect(() => {
		function handleResize() {
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight
			});
		}
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	async function fetchUserData(id: string, token: string) {
		const config = {
			headers: {
				Authorization: 'Bearer ' + token
			}
		};
		let endpoint = `/editor/${id}/get-details`;
		if (isShowingContributedTopics)
			endpoint = `/topic/get-editor-contributed-topics`;
		const { data } = await axiosInstance().get(
			`${globalEnv.BASE_URL}${endpoint}?page=${page}
			${sortBy != null ? '&sortby=' + sortBy : ''}
			${sortOrder != null ? '&order=' + sortOrder : ''}
			${searchQuery != null ? '&filter=' + searchQuery : ''}`,
			config
		);

		if (data.meta.pages < page) {
			setPage(1);
		}
		return data;
	}

	const { data, isLoading, isFetching, isError, isSuccess } = useQuery(
		[
			'topics',
			isShowingContributedTopics,
			page,
			reloadCount,
			sortBy,
			sortOrder,
			searchQuery
		],
		() => fetchUserData(id!, ACCESS_TOKEN),
		{
			keepPreviousData: true,
			refetchOnWindowFocus: false,
			staleTime: 5000
		}
	);

	const setDefaultDashState = (dashboards: any[]) => {
		if (dashboards.length === 1) setSingleDash(true);
		dashboards.some((element) => {
			if (element.default) setDefaultDash(element._id);
		});
	};

	useEffect(() => {
		if (data != null) {
			try {
				if (isShowingContributedTopics) {
					if (data.topics != null) setCreatedTopics(data.topics);
				} else {
					setUserId(data.user._id);
					setUsername(data.user.username);
					setEmail(data.user.email);
					setSignupDate(data.user.createdAt);
					setIsDisabled(data.user.isDisabled);

					setBio(data.user.bio);
					setGender(data.user.gender);
					setLocation(data.user.location);
					setBirthdate(moment(data.user.birthdate).toDate());

					if (
						data.user.socialMediaLinks != null &&
						data.user.socialMediaLinks.length > 0
					) {
						type SocialMediaType = {
							type: string;
							link: string;
						};
						setInstagramLink(
							() =>
								data.user.socialMediaLinks.find(
									(item: SocialMediaType) => item.type === 'instagram'
								).link
						);
						setFacebookLink(
							() =>
								data.user.socialMediaLinks.find(
									(item: SocialMediaType) => item.type === 'facebook'
								).link
						);
						setYoutubeLink(
							() =>
								data.user.socialMediaLinks.find(
									(item: SocialMediaType) => item.type === 'youtube'
								).link
						);
						setTwitterLink(
							() =>
								data.user.socialMediaLinks.find(
									(item: SocialMediaType) => item.type === 'twitter'
								).link
						);
						setPinterestLink(
							() =>
								data.user.socialMediaLinks.find(
									(item: SocialMediaType) => item.type === 'pinterest'
								).link
						);
					}

					if (data.user.photo != null) setPhoto(data.user.photo);

					if (isProfile) {
						setDashboards(data.user.dashboards);
						setDefaultDashState(data.user.dashboards);
					}

					if (data.createdTopics != null)
						setCreatedTopics(data.createdTopics.topics);

					if (moment(data.user.blockExpires) > moment()) {
						setIsBlocked(true);
					}
				}
			} catch (e) {
				console.log('Error occured getting user data');
			}
		}
	}, [data]);

	useEffect(() => {
		console.log('yo', createdTopics);
	}, [createdTopics]);

	useEffect(() => {
		if (isProfile) return;
		if (dashboards.length > 1) setSingleDash(false);
		else setSingleDash(true);
	}, [dashboards]);

	// useEffect(() => {
	// 	const tags: string[] = [];
	// 	createdTopics.forEach((item) => {
	// 		tags.push(item.tags);
	// 	});
	// 	setTags(tags);
	// }, [createdTopics]);

	const SignupAndActivityDates = () => {
		return (
			<div className="flex flex-row">
				{instagramLink != null && instagramLink != '' && (
					<a href={'https://' + instagramLink} target="_blank">
						<FaInstagram
							size={26}
							className="mx-3 text-gray-600 dark:text-gray-300 hover:text-purple-700 dark:hover:text-purple-700 transition-colors duration-500"
						/>
					</a>
				)}
				{facebookLink != null && facebookLink != '' && (
					<a href={'https://' + facebookLink} target="_blank">
						<FaFacebook
							size={26}
							className="mx-3 text-gray-600 dark:text-gray-300 hover:text-purple-700 dark:hover:text-purple-700 transition-colors duration-500"
						/>
					</a>
				)}

				{twitterLink != null && twitterLink != '' && (
					<a href={'https://' + twitterLink} target="_blank">
						<FaTwitter
							size={26}
							className="mx-3 text-gray-600 dark:text-gray-300 hover:text-purple-700 dark:hover:text-purple-700 transition-colors duration-500"
						/>
					</a>
				)}

				{youtubeLink != null && youtubeLink != '' && (
					<a href={'https://' + youtubeLink} target="_blank">
						<FaYoutube
							size={26}
							className="mx-3 text-gray-600 dark:text-gray-300 hover:text-purple-700 dark:hover:text-purple-700 transition-colors duration-500"
						/>
					</a>
				)}
				{pinterestLink != null && pinterestLink != '' && (
					<a href={'https://' + pinterestLink} target="_blank">
						<FaPinterest
							size={26}
							className="mx-3 text-gray-600 dark:text-gray-300 hover:text-purple-700 dark:hover:text-purple-700 transition-colors duration-500"
						/>
					</a>
				)}
			</div>
		);
	};

	const GeneralData = () => {
		return (
			<div className="flex justify-center lg:p-3">
				<div className="px-2 py-0.5 h-fit text-center dark:bg-gray-700 bg-gray-100 rounded-xl ml-2">
					<span className="text-lg font-bold block uppercase tracking-wide text-oldgray-600 dark:text-white transition-all duration-500">
						{createdTopics != null && createdTopics.length}
					</span>
					<span className="text-sm text-gray-500 font-semibold dark:text-gray-400 transition-all duration-500">
						Topics
					</span>
				</div>

				{isProfile && (
					<div className="px-2 py-0.5 h-fit text-center dark:bg-gray-700 bg-gray-100 rounded-xl ml-2">
						<span className="text-lg font-bold block uppercase tracking-wide text-oldgray-600 dark:text-white transition-all duration-500">
							{dashboards.length}
						</span>
						<span className="text-sm text-gray-500 font-semibold dark:text-gray-400 transition-all duration-500">
							Dashboards
						</span>
					</div>
				)}
				<div className="px-2 py-0.5 h-fit text-center dark:bg-gray-700 bg-gray-100 rounded-xl ml-2">
					{isDisabled ? (
						<span className="text-lg block tracking-wide text-red-500 font-bold">
							{'Disabled'}
						</span>
					) : isBlocked ? (
						<span className="text-lg block text-orange-500 font-bold">
							{'Blocked'}
						</span>
					) : (
						<span className="text-lg block text-green-600 font-bold">
							{'Active'}
						</span>
					)}
					<span className="text-sm text-gray-500 font-semibold dark:text-gray-400 transition-all duration-500">
						Status
					</span>
				</div>
			</div>
		);
	};

	const getDashboardDailyImage = (dashboard: any, isBannerImage = false) => {
		const randomImage =
			'https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2710&q=80';

		if (createdTopics == null) return randomImage;

		try {
			const topic = createdTopics.find(
				(topic) => topic._id === dashboard.selectedTopics[0]
			);
			if (topic == null) return randomImage;
			if (isBannerImage) return topic.dailyImage.url;
			if (topic.dailyImage.url_low_res != null)
				return topic.dailyImage.url_low_res;
			return topic.dailyImage.url;
		} catch (e) {
			return randomImage;
		}
	};

	const getBannerImage = () => {
		const randomImage =
			'https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2710&q=80';

		if (dashboards == null) return randomImage;
		// If no dashboard is found, getDashboardDailyImage() will throw an exception and will return a random image
		const dashboard = dashboards.find(
			(dashboard) => dashboard._id === defaultDash
		);
		return getDashboardDailyImage(dashboard, true);
	};

	const navigate = useNavigate();

	return (
		<Scrollbars autoHide>
			{isLoading ? (
				<LoadingAnimComponent />
			) : isError ? (
				<div className="h-full ml-18 ">
					<div className=" flex flex-col mx-auto my-auto text-center align-middle overflow-clip h-full ">
						<div className="mx-auto my-auto self-center">
							<div className="min-h-16">
								<DataNotFoundAnimation height={dimensions.height / 1.5} />
							</div>
							<h3 className="lg:text-2xl text-xl font-bold dark:text-gray-200 text-gray-700 -mt-8">
								{"Couldn't find the data you're looking for!"}
							</h3>
						</div>
					</div>
				</div>
			) : (
				<main className="ml-16">
					<section className="relative block" style={{ height: '500px' }}>
						<div
							className="absolute top-0 w-full h-full bg-center bg-cover rounded-b-2xl"
							style={{
								backgroundImage: `url('${getBannerImage()}')`
							}}
						>
							<span
								id="blackOverlay"
								className="w-full h-full absolute opacity-30 bg-black rounded-b-2xl"
							></span>
						</div>
					</section>
					<section className="relative py-16 bg-gray-300 dark:bg-gray-800 transition-all duration-500">
						<div className="container mx-auto px-4">
							<div className="relative flex flex-col min-w-0 break-words bg-white dark:bg-gray-800 transition-all duration-500 w-full mb-6 shadow-xl rounded-2xl -mt-64">
								<div className="px-6">
									<div className="flex flex-wrap justify-center container sm:px-2 md:px-10 mx-auto lg:px-6 xl:px-32">
										<div className="w-full justify-center lg:justify-start lg:w-4/12 lg:order-1 flex">
											<div className="rounded-full flex justify-center bg-gray-300 dark:bg-gray-700 h-32 w-32 -mt-12 transition-colors duration-500">
												<LazyImage
													photo={
														photo != null
															? photo
															: `https://api.dicebear.com/7.x/bottts/svg?seed=${username}`
													}
													dimesnions={{ width: '140', height: '140' }}
													loaderDimesnions={80}
												/>
											</div>
											<div className="mt-3 ml-3">
												<h3 className="text-xl font-bold leading-normal dark:text-white text-oldgray-800 transition-colors duration-500">
													{username}
												</h3>
												<h3 className="text-sm font-semibold leading-normal text-gray-500 transition-colors duration-500">
													{email}
												</h3>
											</div>
										</div>

										<div className="w-full lg:w-4/12 px-4 order-2 mt-2 lg:mt-0">
											<GeneralData />
										</div>

										<div className="flex flex-row lg:w-4/12 order-2 lg:order-3 pt-5 justify-end">
											<div className="pt-1">
												<SignupAndActivityDates />
											</div>
											{isProfile ? (
												<div className="lg:text-right">
													<div className="px-3">
														<button
															className="btn btn-outline btn-sm btn-primary"
															type="button"
															style={{ transition: 'all .15s ease' }}
															onClick={() => {
																navigate('./edit');
															}}
														>
															Edit
														</button>
													</div>
												</div>
											) : (
												<div className="lg:text-right">
													<div className="px-3">
														<button
															className="btn btn-outline btn-sm btn-primary"
															type="button"
															style={{ transition: 'all .15s ease' }}
														>
															Contact
														</button>
													</div>
												</div>
											)}
										</div>
									</div>

									<div className="sm:px-2 md:px-10 lg:px-6 xl:px-36 lg:mt-3 lg:mb-0">
										<h3 className="font-bold mb-2 text-sm lg:text-base dark:text-gray-100">
											Topic Tags
										</h3>
										<div className="flex flex-row space-x-2">
											{tags.length > 0 ? (
												tags.map((tag, index) => (
													<Tag
														name={tag}
														isMine={false}
														setIsChanged={() => {
															return;
														}}
														index={index}
														setTags={setTags}
														tags={tags}
													/>
												))
											) : (
												<div className="inline-block">
													<span className="text-xs font-bold mx-1 text-gray-600">
														User's topics have no Tags
													</span>
												</div>
											)}
										</div>
									</div>

									{/* CARD */}
									{isProfile && (
										<div className="">
											<div className="lg:mt-8">
												<div className="grid grid-cols-2 lg:px-[10%] px-[3%] mb-3">
													<h3 className="mt-3 sm:mt-2 text-xl sm:text-3xl font-bold text-gray-700 dark:text-gray-500">
														My Meavana Dashboards
													</h3>
													<ParentModal
														visible={isAddDashModalOpen}
														setModalOpen={setDashModalOpen}
														isChanged={isAddDashModalChanged}
														setIsChanged={setIsAddDashModalChanged}
														isWarnModalOpen={isWarnModalOpen}
														setIsWarnModalOpen={setIsWarnModalOpen}
													>
														<DashboardAddModalContent
															userId={userId}
															setOpen={setDashModalOpen}
															topics={createdTopics}
															dashboards={dashboards}
															setDashboards={setDashboards}
															isChanged={isAddDashModalChanged}
															setIsChanged={setIsAddDashModalChanged}
															setIsWarnModalOpen={setIsWarnModalOpen}
														/>
													</ParentModal>

													<button
														className="btn btn-outline btn-sm btn-primary ml-auto mt-3"
														onClick={() => {
															setDashModalOpen(true);
														}}
													>
														Add ➕
													</button>
												</div>
												<div className="mt-3">
													<div className="w-full lg:w-10/12 lg:px-4 mx-auto">
														<div className="">
															<div className="flex flex-wrap  lg:flex-grow justify-center">
																{dashboards.map((item: any) => (
																	<DashCard
																		key={item._id}
																		dashboardId={item._id}
																		userId={userId}
																		image={getDashboardDailyImage(item)}
																		name={item.title}
																		defaultDash={defaultDash}
																		setDefaultDash={setDefaultDash}
																		dashboardList={dashboards}
																		setDashboards={setDashboards}
																	/>
																))}
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									)}

									{/* Topics */}

									<div className="lg:mt-8">
										<div className="border-t mt-8 border-gray-300 dark:border-gray-700 transition-all duration-500 w-8/12 mx-auto mb-5" />
										{createdTopics.length > 0 ? (
											<div className="mb-20">
												<div className="w-10/12 h-16 flex flex-row mx-auto">
													<button
														type="button"
														className="relative w-full py-2.5 px-5 mb-2 text-lg font-bold text-gray-900 
														border-r border-gray-200  hover:text-purple-700 dark:text-gray-400
													dark:border-gray-600 dark:hover:text-white"
														onClick={() => {
															setIsShowingContributedTopics(false);
															setPage(1);
														}}
													>
														<div
															className={`absolute inset-0 pb-1 bg-gradient-to-b dark:from-gray-600/50 from-gray-400/50 opacity-0
													hover:opacity-100 transition-all duration-500 text-center
													${!isShowingContributedTopics && 'opacity-80'}`}
														/>
														Created Topics
													</button>
													<button
														type="button"
														className="relative w-full py-2.5 px-5 mb-2 text-lg font-bold text-gray-900 
														 border-gray-200 hover:text-purple-700 dark:text-gray-400
														dark:border-gray-600 dark:hover:text-white"
														onClick={() => {
															setIsShowingContributedTopics(true);
															setPage(1);
														}}
													>
														<div
															className={`absolute inset-0 pb-1 bg-gradient-to-b dark:from-gray-600/50 from-gray-400/50 opacity-0 
													hover:opacity-100 transition-all duration-500 text-center
													${isShowingContributedTopics && 'opacity-80'}`}
														/>
														Contributions
													</button>
												</div>

												<div className="flex flex-row justify-end mt-3">
													<div className="flex flex-row justify-end lg:px-[10%] px-[3%]">
														<div className="">
															<SearchBar
																searchPlaceholder="Search created topics"
																setSearchQuery={setSearchQuery}
															/>
														</div>
														<div className="leading-normal mb-2 text-gray-500 dark:text-white text-left w-40 mr-2">
															<select
																id="Status"
																className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-1.5 pb-2 ml-2
																focus:ring-purple-500 focus:border-purple-500 dark:bg-gray-700 dark:border-gray-600 duration-500 transition-all
																dark:placeholder-gray-400 dark:text-white dark:focus:ring-purple-500 dark:focus:border-purple-500"
																onChange={(e) => {
																	const arr = e.target.value.split('-');
																	setSortBy(arr[0]);
																	arr[1] === 'desc'
																		? setSortOrder(sortingOrder.DESCENDING)
																		: setSortOrder(sortingOrder.ASCENDING);
																}}
															>
																<option selected={true} value="name-asc">
																	Topic name - A-Z
																</option>
																<option selected={true} value="name-desc">
																	Topic name - Z-A
																</option>

																<option value="createdAt-desc">
																	Creation date - Descending
																</option>
																<option value="createdAt-asc">
																	Creation date - Ascending
																</option>

																<option value="usersCount-desc">
																	Users count - Descending
																</option>
																<option value="usersCount-asc">
																	Users count - Ascending
																</option>

																<option value="imagesCount-desc">
																	images count - Descending
																</option>
																<option value="imagesCount-asc">
																	images count - Ascending
																</option>
															</select>
														</div>
													</div>
												</div>
												<section className="container mx-auto md:px-4 py-4 lg:px-[7%] px-[3%] mb-3">
													<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-items-center gap-4">
														{isFetching || isLoading ? (
															<LoadingRectanglesAnimation />
														) : (
															createdTopics.map((item: any) => (
																<TopicCard
																	key={item._id}
																	id={item._id}
																	name={item.name}
																	createdAt={item.createdAt}
																	imagesCount={item.imagesCount}
																	usersCount={item.usersCount}
																	image={item.backgroundImage}
																	creator={{
																		_id: userId,
																		email: email,
																		username: username,
																		photo: photo
																	}}
																	contributors={item.contributors}
																	isContributor={false}
																	tags={item.tags}
																	isComplete={item.isComplete}
																	status={item.reviewStatus}
																	reloadCount={reloadCount}
																	setReloadCount={setReloadCount}
																	topics={createdTopics}
																	setTopics={setCreatedTopics}
																/>
															))
														)}
													</div>
												</section>
												{isSuccess && (
													<div className="flex justify-center mt-3">
														<Pagination
															itemsPerPage={data.meta.limit}
															totalCount={data.meta.total}
															totalPages={data.meta.pages}
															currentPage={page}
															setPage={setPage}
														/>
													</div>
												)}
											</div>
										) : (
											<div className="flex flex-col w-8/12 mt-10 mb-20 mx-auto">
												<h3 className="font-bold text-4xl dark:text-gray-500 text-center">
													You don't have any created topics..
												</h3>
												<h3 className="font-bold text-5xl dark:text-gray-500 text-center mt-1">
													Click on the button below to create your
												</h3>
												<h3 className="font-bold text-6xl dark:text-gray-500 text-center mt-2">
													First Topic
												</h3>

												<button
													className="btn btn-outline btn-sm btn-primary mx-auto mt-8"
													onClick={() => {
														navigate('../add-topic');
													}}
												>
													Create My First Topic ➕
												</button>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</section>
				</main>
			)}
		</Scrollbars>
	);
}
